import React from 'react'
import { SecurityQuestionsForm } from 'front-end/src/pages/auth/security-questions/SecurityQuestionsForm'
import { HeadTitle } from 'front-end/src/components/common/head/HeadTitle'
import { WithSecurityQuestionsFormik } from 'front-end/src/pages/auth/security-questions/SecurityQuestionsFormik'
import { SecurityQuestionsController } from 'front-end/src/pages/auth/security-questions/SecurityQuestionsController'
import { t } from '@lingui/macro'

type SecurityQuestionsProps = {
  submit(): Promise<boolean>
}

export const SecurityQuestions: React.FC<SecurityQuestionsProps> = ({
  submit
}) => {
  return (
    <>
      <HeadTitle title={t`Security questions`} />

      <SecurityQuestionsController submit={submit}>
        {(onFormSubmit, signupLoading) => (
          <WithSecurityQuestionsFormik onSubmit={onFormSubmit}>
            <SecurityQuestionsForm signupLoading={signupLoading} />
          </WithSecurityQuestionsFormik>
        )}
      </SecurityQuestionsController>
    </>
  )
}
